module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-06-577634842cf36f66fb27cb058614ceb3.jpg";